// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__y2iwu","primary":"Button_primary__x2lr7","secondary":"Button_secondary__A+XQl","success":"Button_success__wPzgm","danger":"Button_danger__1+gZa"};